<script setup>
import {onMounted, ref} from "vue";

const props = defineProps({
  backgroundColor: {
    type: String,
    default: "#FFF"
  }
});

const cardRef = ref(null);

onMounted(() => {
  cardRef.value.style.backgroundColor = props.backgroundColor;
});
</script>

<template>
  <div
    ref="cardRef"
    class="card"
  >
    <slot />
  </div>
</template>

<style scoped lang="scss">
.card {
  box-shadow: 0 4px 8px 0 #00000024;
  background: #FFFFFF;
  padding: 20px;
  border-radius: 10px;
}
</style>